const API_URL = process.env.REACT_APP_API_URL;

// 📊 Placed Chart API
export const getPlacedReport = async (filters = {}) => {
  const token = localStorage.getItem("token");

  const query = new URLSearchParams(filters).toString();

  const res = await fetch(`${API_URL}/reports/placed?${query}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  return res.json();
};

// 🥧 Awaiting Chart API
export const getAwaitingReport = async (filters = {}) => {
  const token = localStorage.getItem("token");

  const query = new URLSearchParams(filters).toString();

  const res = await fetch(`${API_URL}/reports/awaiting?${query}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  return res.json();
};

// 📊 Job Requirement Report API
export const getJobRequirementReport = async (filters = {}) => {
  const token = localStorage.getItem("token");

  const query = new URLSearchParams(filters).toString();

  const res = await fetch(
    `${API_URL}/reports/job?${query}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return res.json();
};

export const getJobRequirementDetails = async (
    filters = {}
) => {

    const token = localStorage.getItem("token");

    const query =
        new URLSearchParams(filters).toString();

    const res = await fetch(
        `${API_URL}/reports/job-requirement/details?${query}`,
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );

    return res.json();
};
export const getPlacedStudentsDetails = async (
    filters = {}
) => {

    const token = localStorage.getItem("token");

    const query =
        new URLSearchParams(filters).toString();

    const res = await fetch(
        `${API_URL}/reports/placed/details?${query}`,
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );

    return res.json();
};
export const getPlacedByReport = async (
    filters = {}
) => {

    const token =
        localStorage.getItem("token");

    const query =
        new URLSearchParams(filters)
            .toString();

    const res = await fetch(
        `${API_URL}/reports/placedby/details?${query}`,
        {
            headers: {
                Authorization:
                    `Bearer ${token}`
            }
        }
    );

    return res.json();
};